import '../../sendOtp/sendOtp.scss';
import React from 'react';
import { Translate, translate, Storage } from 'react-jhipster';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Row, Col, Button, Alert } from 'reactstrap';
import OtpInput from 'react-otp-input';
import { IRootState } from 'app/shared/reducers';
import { getSession } from 'app/shared/reducers/authentication';
import { sendOtp, reSendOtp, reset, generateCaptcha } from './password-reset.reducer';
import { NUMBER_OTP_FAIL, CHANGE_PHONE } from 'app/config/constants';
import ModalInputCaptcha from './modal-resend-otp';

export interface ISendOtpProps extends StateProps, DispatchProps, RouteComponentProps<{}> {}

export interface ISendOtpState {
  otp: string;
  visible: boolean;
  color: string;
  message: string;
  redirectReg: boolean;
  displayModalCaptcha: boolean;
  alertMess: string;
  isOpenAlert: boolean;
  typeSendOtp: string;
}
export class SendOtpPage extends React.Component<ISendOtpProps, ISendOtpState> {
  state: ISendOtpState = {
    otp: '',
    visible: false,
    color: 'info',
    message: '',
    redirectReg: false,
    displayModalCaptcha: false,
    alertMess: '',
    isOpenAlert: false,
    typeSendOtp: 'EMAIL'
  };
  componentDidMount() {
    // this.props.reset();
    // this.props.getSession();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.response !== nextProps.response) {
      const { response } = nextProps;
      if (response && response.status === 'KEY_NOT_CORRECT') {
        let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
        count = count + 1;
        Storage.session.set('count', count);
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message,
          otp: ''
        });
      } else if (response && response.status !== 'SUCCESS') {
        this.setState({
          visible: true,
          color: 'danger',
          message: response.message
        });
      }
    }

    if (this.props.responseReSend !== nextProps.responseReSend) {
      const { responseReSend } = nextProps;
      if (responseReSend && responseReSend.status === 'SUCCESS') {
        Storage.session.remove('count');
        this.setState({
          visible: true,
          color: 'success',
          message:
            this.state.typeSendOtp === 'SMS'
              ? translate('sendOtp.messages.sendotpSuccess')
              : translate('sendOtp.messages.sendotpSuccessTypeEmail'),
          displayModalCaptcha: false,
          isOpenAlert: false,
          otp: ''
        });
      } else if (responseReSend && responseReSend.status) {
        this.props.generateCaptcha();
        this.setState({
          // visible: true,
          color: 'danger',
          // message: responseReSend.message,
          alertMess: responseReSend.message,
          isOpenAlert: true
        });
      }
      this.props.generateCaptcha();
    }
    let timerId = setTimeout(() => {
      this.setState({
        visible: false
      });
      //this.props.reset();
    }, 3000);
  }

  componentWillUnmount() {
    //this.props.reset();
  }

  handleValidSubmit = () => {
    const { mobile, id } = this.props.location.state;
    let count = Storage.session.get('count') ? Storage.session.get('count') : 0;
    if (count < NUMBER_OTP_FAIL) {
      if (this.state.otp) {
        this.props.sendOtp(id, mobile, this.state.otp);
      } else {
        this.setState({
          visible: true,
          color: 'info',
          message: 'Bạn chưa nhập mã OTP.'
        });
        let timerId = setTimeout(() => {
          this.setState({
            visible: false
          });
        }, 3000);
      }
      count = count + 1;
      Storage.session.set('count', count);
    } else {
      Storage.session.remove('count');
      this.setState({ redirectReg: true });
    }
  };

  handleReSendOtp = () => {
    const { id, email, mobile } = this.props.location.state;
    if (mobile) {
      this.setState({
        displayModalCaptcha: true
      });
    } else {
      const { id, mobile } = this.props.location.state;
      this.props.reSendOtp(id, email, '');
    }
  };

  onDismiss = () => {
    this.setState({ visible: false });
  };

  invokeAgree = type => {
    const { id, email, mobile } = this.props.location.state;
    this.setState({ typeSendOtp: type });
    if (type === 'SMS') {
      this.props.reSendOtp(id, mobile, '');
    } else {
      this.props.reSendOtp(id, email, '');
    }
  };

  invokeCancel = () => {
    this.setState({
      displayModalCaptcha: false
    });
  };

  invokeDimiss = () => {
    this.setState({
      isOpenAlert: false
    });
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.handleValidSubmit();
    }
  };

  render() {
    if (!this.props.location.state) {
      return <div />;
    }
    const { response } = this.props;
    let { email, id, name, mobile, fullName } = this.props.location.state;
    let sdt = this.state.typeSendOtp === 'SMS' ? mobile : email;

    if (response && response.status === 'SUCCESS') {
      return (
        <Redirect
          push
          to={{
            pathname: `/reset/finish/${id}`,
            state: {
              name: name
            }
          }}
        />
      );
    }

    if (this.state.redirectReg) {
      return <Redirect push to="/register" />;
    }

    // if (email) {
    //   email = email.startsWith('84') ? email.replace('84', '0') : email;
    //   //sdt = mobile.slice(0, 4) + '****' + mobile.slice(8, 11);
    //   sdt = email.slice(0, 3) + '****' + email.slice(7, email.length);
    // }

    return (
      <div>
        {window['inputNumber']()}
        <ModalInputCaptcha
          showModalCaptcha={this.state.displayModalCaptcha}
          invokeAgree={this.invokeAgree}
          invokeCancel={this.invokeCancel}
          errMessage={this.state.alertMess}
          isOpenAlert={this.state.isOpenAlert}
          dismissAlert={this.invokeDimiss}
          fullName={fullName}
          mobile={mobile}
          email={email}
        />

        <Row className="justify-content-center">
          <Col className="box-otp">
            <h2 className="text-center font-weight-bold" id="password-title">
              <Translate contentKey="sendOtp.title">Nhập mã OTP</Translate>
            </h2>
            <h6 className="text-center txtContent font-weight-bold">
              <Translate contentKey="sendOtp.txtContent1" interpolate={{ email: sdt }}>
                Otp code has been sent via phone number: {sdt}
              </Translate>
            </h6>

            <Alert color={this.state.color} isOpen={this.state.visible} toggle={this.onDismiss}>
              {this.state.message}
            </Alert>

            <AvForm className="text-center" id="password-form" onValidSubmit={this.handleValidSubmit} onKeyPress={this.handleKeyPress}>
              <p className="text-center">Nhập mã OTP</p>
              <div id="inputOtp">
                <OtpInput
                  inputStyle={{
                    width: '2.5rem',
                    height: '2.5rem',
                    margin: '5px 5px',
                    fontSize: '1.5rem',
                    border: '1px solid rgba(0,0,0,0.3)'
                  }}
                  numInputs={6}
                  onChange={otp => this.setState({ otp })}
                  value={this.state.otp}
                  shouldAutoFocus
                />
              </div>

              <p className="text-center">
                Bạn chưa nhận được mã?
                <Button className="btnLink" color="link" style={{ color: '#4D9235' }} type="button" onClick={this.handleReSendOtp}>
                  Gửi lại OTP
                </Button>
              </p>

              <Button className="btn-register" type="submit" block>
                <Translate contentKey="sendOtp.form.button">Confirm</Translate>
              </Button>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = ({ passwordReset }: IRootState) => ({
  response: passwordReset.response,
  responseReSend: passwordReset.responseReSend
});

const mapDispatchToProps = { getSession, sendOtp, reSendOtp, reset, generateCaptcha };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SendOtpPage);
